export default "__VITE_ASSET__0xSh2Rwk__"